import React, { useState, useEffect } from "react";
import Draggable from "react-draggable";

var flag = true;

export const AudioTrack = (props) => {
  // useEffect(() => {

  //     if (props) {
  //         props.setPositionX(props.value.x)
  //     }

  // }, [props])

  const AudioSlider = (e) => {
    if (props.play === true) {
      if (flag === true) {
        var Slideroffset = e.target.getBoundingClientRect();

        var currentPositionX = (e.pageX - Slideroffset.left) / 2.26;

        var selectTime = (props.time / 100) * currentPositionX;

        props.AudioRef.current.currentTime = Math.round(selectTime);

        props.setwidth(Math.round(currentPositionX));

        props.setPositionX(Math.round(e.pageX - Slideroffset.left));
      }
    }
  };

  const drag = (e, position) => {
    props.setPositionX(position.x);

    props.setwidth(Math.round(position.x / 2.26));

    props.AudioRef.current.currentTime = Math.round(
      (props.time / 100) * (position.x / 2.26)
    );
  };

  const dragEnd = (e, position) => {
    setTimeout(function () {
      flag = true;
    }, 200);
  };

  const dragstart = (params) => {
    flag = false;
  };

  return (
    <>
      <div className="Music_player_detail">
        <div className="MusicBox_soundWave Music_blindWave"></div>

        <div
          className="MusicBox_soundWave Music_ColorWave"
          style={{ width: props.width + "%" }}
        ></div>

        <div className="MusicBoxSlider" onClick={AudioSlider}>
          <div className="MusicBox_Rail"></div>

          <div
            className="MusicBox_Tracks"
            style={{ left: "0%", right: "auto", width: props.width + "%" }}
          ></div>

          {props.play === true && (
            <Draggable
              onStart={dragstart}
              defaultPosition={{ x: 0, y: 0 }}
              bounds={{ left: 0, right: 230 }}
              onDrag={drag}
              axis="x"
              onStop={dragEnd}
              position={{ x: props.PositionX, y: 0 }}
            >
              <div
                className="MusicSlideHandler"
                aria-valuemin="0"
                style={{ left: "-4.5px", right: "auto", opacity: "0.7" }}
              ></div>
            </Draggable>
          )}

          {props.play === false && (
            <div
              className="MusicSlideHandler"
              aria-valuemin="0"
              style={{
                left: props.width + "%",
                right: "auto",
                transform: "translateX(-50%)",
                opacity: "0.7",
              }}
            ></div>
          )}

          <div className="Music_Mark"></div>
        </div>
      </div>
    </>
  );
};
export default AudioTrack;
